interface LogsShowMoreProps {
    onClick: () => void;
}

export const LogsShowMore = ({ onClick }: LogsShowMoreProps) => {
    return (
        <span onClick={onClick} className="text-13 underline text-sf-gray-400 cursor-pointer">
            Show more in Authentication Logs
        </span>
    );
};
